export const svg = [
    {
        icon : "linkedIn",
        link : "https://www.linkedin.com/in/eiden0/",
        src : require('./linkedin.svg'),
    },
    {
        icon : 'facebook',
        link : "https://www.facebook.com/Eiden0",
        src : require('./facebook.svg'),
    },
    {
        icon : 'github',
        link : "https://github.com/Eiden0",
        src : require('./github.svg'),
    },
    {
        icon : 'gmail',
        link : "mailto:shibashis12@gmail.com",
        src : require('./gmail.svg'),
    },
];

export const setting_svg = {
  icon : 'settings',
  src : require('./settings.svg')
}

export const cross = {
  icon : 'cross',
  src : require('./red_x.svg')
}